import React, {useState, useEffect, useRef, useMemo} from 'react'
import {Image, Space, PreviewGroup, Modal, Tag} from '@bedrock/components'
import {Play} from '@bedrock/icons-react'
import {useMemoizedFn} from 'ahooks'
import classNames from 'classnames/bind'
import styles from './index.less'
import { TagColor } from '@bedrock/components/lib/Tag'

const conf: Record<string, { panelHeaderbgClassName: string, tagColor: TagColor, text?: string }> = {
  // no_overtime: { panelHeaderbgClassName: 'panel_header_bg_green', tagColor: 'green', text: '未超时' },
  // overtime_48: { panelHeaderbgClassName: 'panel_header_bg_orange', tagColor: 'orange', text: '已超48小时' },
  // overtime_120 : { panelHeaderbgClassName: 'panel_header_bg_red', tagColor: 'red', text: '已超时120小时' },
  '0': { panelHeaderbgClassName: 'panel_header_bg_green', tagColor: 'green' },
  '1': { panelHeaderbgClassName: 'panel_header_bg_orange', tagColor: 'orange' },
  '2' : { panelHeaderbgClassName: 'panel_header_bg_red', tagColor: 'red' },
};

const cx = classNames.bind(styles)

export default function OvertimeTag({ delay_grade,  delay_label, className = 'marginLeft_8', tagCompColorLight = false }) {
  const currConf = conf[delay_grade];
  return !currConf ? null : (
    <Tag
      className={cx(className)}
      color={`${tagCompColorLight ? 'light-' : ''}${currConf.tagColor}` as TagColor} 
      text={delay_label}
      size="xSmall"
    />
  )
}

OvertimeTag.conf = conf;
